export const CHEVRON_RIGHT_SIZE = '16px';
export const TICK_MARK_SIZE = '16px';

export const TEXT = {
  APPLY_COUPON_BAG: 'Apply coupon on bag',
  OFFER_APPLIED: 'Offer applied',
  SHOP_MORE: 'Shop for <price> more',
};

export const PLP_REDIRECT_URL = '/op';

export interface DeltaConfigType {
  offerSuccessMessage: string;
  couponSuccessMessage: string;
  deltaOfferColor: string;
  deltaCouponColor: string;
  deltaOfferTextColor: string;
  deltaCouponTextColor: string;
  deltaOfferSuccessColor: string;
  deltaCouponSuccessColor: string;
  deltaOfferSuccessTextColor: string;
  deltaCouponSuccessTextColor: string;
  enableDesktop: boolean;
}

export enum COUPON_CLICK_TYPE {
  COUPON = 'coupon',
  OFFER = 'offer',
}

export const COUPON_PAGE_TYPE = {
  COUPON_LISTING_TYPE: 'couponListingPage',
  OFFER_LISTING_TYPE: 'offerListingPage',
};
